import React from 'react'
import { useState, useEffect } from 'react';
import styled from 'styled-components'
import { CurrencyState } from "../Context";
import { Link } from 'react-router-dom';

function AddFunds() {

    document.title = "Add Funds | Lehumo";

    const { currency, symbol } = CurrencyState();


    const minimumDollar = 1.00;
    const minimumRand = 20.00;
    const minimumNaira = 500.00;

    const maxDollar = 300000.00;
    const maxRand = 5000000.00;
    const maxNaira = 138162000.00;

    const [minimumDeposit, setMinimumDeposit] = useState(minimumDollar);
    const [maxDeposit, setMaxDeposit] = useState(maxDollar);

    useEffect(() => {

        //Set minimum deposit amount based on the currency

        if (currency === "USD") setMinimumDeposit(minimumDollar) && setMaxDeposit(maxDollar);
        else if (currency === "ZAR") setMinimumDeposit(minimumRand) && setMaxDeposit(maxRand);
        else if (currency === "NGN") setMinimumDeposit(minimumNaira) && setMaxDeposit(maxNaira);

        //Set maximum deposit amount based on the currency

        if (currency === "USD") setMaxDeposit(maxDollar);
        else if (currency === "ZAR") setMaxDeposit(maxRand);
        else if (currency === "NGN") setMaxDeposit(maxNaira);

    }, [currency]);


    return (
        <>
            <Box><br />

                <BackButton>
                    <Link to="/Portfolio"><button><i className="fa-solid fa-arrow-left"></i> Back</button></Link>
                </BackButton>

                <h3>How much would you like to deposit?</h3>


                <center>
                    <InputForm>

                        <form>
                            <select disabled>
                                <option>{currency}</option>
                            </select>
                            <input name="amount" type="number" placeholder="Amount" />



                            <Notice>
                                <h3>
                                    Minimum: {symbol} {minimumDeposit}
                                    <br />
                                    Maximum: {symbol} {maxDeposit}
                                </h3>
                            </Notice>


                            <Notice>
                                <h2>Bank transfer</h2>
                                <p>Deposit reflects in 2 - 3 days.</p>
                            </Notice>

                            <button type='submit'>Next</button>

                        </form>

                    </InputForm>

                </center>
                <br />

            </Box>
        </>
    )
}

export default AddFunds

const Box = styled.div`

    background-color: #fff;
    width: 60%;
    height: auto;
    box-shadow: rgba(99, 99, 99, 0.4) 0px 2px 8px 0px;
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 100px;
    text-align: center;

    h1 {
        padding-top: 50px;
        font-weight: 400;
        font-size: 42px;
        text-transform: uppercase;
    }

    h3 {
        margin: 20px 0;
        font-weight: 600;
        font-size: 24px;
        text-transform: uppercase;
    }


    @media (max-width: 768px) {
        width: 95%;

        
        h1 {
            
            font-size: 24px;
        }

    }

`

const Notice = styled.div`
    width: 60%;
    height: 100px;
    background-color: #efeded;
    justify-content: left;
    align-items: center;
    border-radius: 5px;
    margin: 10px 10px;
 
    h2 {
        margin: 10px auto;
        padding-top: 25px;
        text-align: center;
        color: #333;
        font-size: 16px;
        font-weight: 600;
        text-transform: uppercase;
    }

     
    h3 {
        margin: 10px auto;
        padding-top: 25px;
        text-align: center;
        color: #333;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 2;
    }

    p {
        font-size: 13px;
    }


    @media (max-width: 768px) {
        width: 95%;
        margin: 10px 2px;
        
        h2 {
            font-weight: 400;
        }

    }

`

const InputForm = styled.div`

    input {
        width: 50%;
        height: 50px;
        border: 2px solid green;
        outline: none;
        padding-left: 20px;
        
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    margin: 0;
    }

    select {
        width: 10%;
        height: 50px;
        border: 2px solid var(--primary);
        outline: none;
        text-align: center;
        font-weight: bold;
        margin-right: 5px;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-transform: uppercase;
        background-color: var(--primary);
        color: #fff;
    }

    button {
        width: 200px;
        height: 50px;
        margin-top: 5px;
        text-transform: uppercase;
        background-color: var(--primary);
        border: none;
        color: #fff;
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        font-weight: 700;
        font-size: 1.1rem;

        :hover {
            box-shadow: rgb(0 0 0 / 15%) 0px 8px 24px;
        }
    }

    @media (max-width: 768px) {

        input {
            width: 70%;
            height: 50px;
            border: 2px solid var(--primary);
            outline: none;
            padding-left: 20px;
        }

        select {
            width: 20%;
            height: 50px;
            border: 2px solid var(--primary);
            outline: none;
            padding-left: 10px;
            font-weight: bold;
            margin-right: 5px;
        }

    }

`

const BackButton = styled.div`

    button {
        width: 60px;
        height: 30px;
        border: none;
        font-size: 11px;
        background-color: transparent;
        text-align: center;
        font-weight: 700;
        color: #333;

        :hover {
            background-color: rgb(17, 140, 79, 0.3);
            border: none;
            transition: 0.3s ease-in;
        }
    }

`